<top-navigation class="d-print-none"></top-navigation>

<main>
    <main-banner></main-banner>

    <app-about-gard-section class="offset"></app-about-gard-section>

    <app-how-gard-helps></app-how-gard-helps>

    <!-- <h4-not-alone></h4-not-alone> -->

    <app-connect-with-gard></app-connect-with-gard>
</main>

<app-footer></app-footer>

<script type="application/ld+json">
    {
        "@context": "https://schema.org",
        "@type": "GovernmentOrganization",
        "name": "Genetic and Rare Diseases Information Center",
        "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "telephone": "+1-888-205-2311"
        }
    }
</script>
